/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Metadata_NoInputs */



/**
* | output |
* | --- |
* | "No" |
*
* @param {Iconik_Metadata_NoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_metadata_no = /** @type {((inputs?: Iconik_Metadata_NoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Metadata_NoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("No")
	if (locale === "de") return /** @type {LocalizedString} */ ("No")
	if (locale === "it") return /** @type {LocalizedString} */ ("No")
	if (locale === "ru") return /** @type {LocalizedString} */ ("No")
	if (locale === "es") return /** @type {LocalizedString} */ ("No")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("No")
	if (locale === "ja") return /** @type {LocalizedString} */ ("No")
	if (locale === "hi") return /** @type {LocalizedString} */ ("No")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("No")
	return /** @type {LocalizedString} */ ("No")
});